import type { PaymentMethodItem } from '@app/_proto/Protos/payments';
import { GetProductsRequest, type ProductItem, ProductType } from '@app/_proto/Protos/products';
import { ProductsClient } from '@app/_proto/Protos/products.client';
import KarmaProduct from '@app/components/karma/karma.product';
import { useGrpcApiWithQuery } from '@app/libs/api';
import { useGrpcRequest } from '@app/libs/grpc';
import * as React from 'react';

export type KarmaProductsProps = {
    paymentMethod: PaymentMethodItem | null;
    loading?: boolean;
    onPurchase?: (product: ProductItem) => void;
};

export default function KarmaProducts({ paymentMethod, loading, onPurchase }: KarmaProductsProps) {
    const request = useGrpcRequest(GetProductsRequest, {
        type: ProductType.KarmaProduct,
    });

    const { data } = useGrpcApiWithQuery(
        ProductsClient,
        c => c.getProducts,
        request,
        ['products', ProductType.KarmaProduct],
        {
            cacheTime: 1000 * 60 * 60 * 24, //Data cached for 24 hours
            staleTime: 1000 * 60 * 60 * 24, //Data stales in 24 hours
        }
    );

    const items = data?.items || [];

    return (
        <div className="grid grid-cols-[repeat(auto-fill,_140px)] justify-center gap-[10px]">
            {items.map(it => (
                <div
                    className="flex w-[140px] items-center justify-center rounded-[8px] px-[20px] py-[18px] shadow dark:bg-[#131415]"
                    key={it.id}
                >
                    <KarmaProduct product={it} disabled={!paymentMethod || loading} onPurchase={onPurchase} />
                </div>
            ))}
        </div>
    );
}
